import { useInView } from 'react-intersection-observer';
import 'animate.css';

export default function AnimatedSection({ children }: { children: React.ReactNode }) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div
      ref={ref}
      className={`transition-opacity duration-100 ${
        inView ? 'animate__animated animate__fadeIn animate__zoomIn' : 'opacity-0'
      }`}
    >
      {children}
    </div>
  );
}
